import { DateTime } from 'luxon';

import BaseEvaluator from './BaseEvaluator';

export default class DateTimeEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'date_time';
  }

  validate() {
    if (this.value === null || this.value === '') {
      // Allow blank
      this.isValid = true;
    } else if (
      (this.value instanceof DateTime && (this.value as DateTime).isValid) ||
      (this.value instanceof Date && DateTime.fromJSDate(this.value as Date).isValid) ||
      (this.value instanceof String && DateTime.fromISO(`${this.value}`).isValid)
    ) {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
    return this.isValid;
  }
}
